module.exports = __webpack_public_path__ + "img/svg/attention.eb03abfab6c1825101e896d956558f2d.svg";